import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { Menu } from './components/Menu';
import { Gallery } from './components/Gallery';
import { Chef } from './components/Chef';
import { Testimonials } from './components/Testimonials';
import { Reservation } from './components/Reservation';
import { Footer } from './components/Footer';
export function App() {
  return <div dir="rtl" lang="he" className="min-h-screen bg-espresso text-cream font-sans selection:bg-gold selection:text-espresso" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Story data-id="element-4" />
        <Menu data-id="element-5" />
        <Gallery data-id="element-6" />
        <Chef data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Reservation data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}